import { render, staticRenderFns } from "./ArticleInfoSources.vue?vue&type=template&id=4e93d03c&scoped=true&v-if=sources%5B0%5D.value.length&"
import script from "./ArticleInfoSources.vue?vue&type=script&lang=ts&"
export * from "./ArticleInfoSources.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleInfoSources.vue?vue&type=style&index=0&id=4e93d03c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e93d03c",
  null
  
)

export default component.exports